/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 19:22:22
 * @LastEditors: yd
 * @LastEditTime: 2020-09-12 16:38:53
 * @FilePath: \mrc-base-server-view\src\service\api\data-access-strategy.js
 */
// 数据策略管理接口
import http from '../httpConfig'
const table = 'mrbase_sys_data_strategy_master'


// 列表
export const listData = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/data/permission/list-data-permission/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 详情
export const getData = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/data/permission/find-data-permission_list/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}


// 修改
export const updateData = (params = {}) => {
    // params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/data/permission/update-data-permission_details/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 基础资料修改
export const updatebasis = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/data/permission/update-data-permission_basics/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 添加
export const addData = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/data/permission/add-data-permission/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 删除
export const delData = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/data/permission/delete-data-permission/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}


// 请求模块树 
export const getTreeList = (params = {}) => {
    params['~table~'] = "mrbase_sys_modules"
    return new Promise((resolve, reject) => {
        http.post('/api/data/permission/list-module-functions/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}


// 数据策略请假申请列表
export const getTestLeaveApplicationList = (params = {}) => {
    params['~table~'] = "mrbase_sys_ask_for_leave"
    return new Promise((resolve, reject) => {
        http.post('/api/leave/list/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 数据策略请假申请列表添加 
export const getTestLeaveApplicationAdd = (params = {}) => {
    params['~table~'] = "mrbase_sys_ask_for_leave"
    return new Promise((resolve, reject) => {
        http.post('/api/leave/save/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}


// 数据策略 报销列表
export const getTestclaim_expenseList = (params = {}) => {
        params['~table~'] = "mrbase_sys_expense_claim"
        return new Promise((resolve, reject) => {
            http.post('/api/claim_expense/list/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    // 数据策略 报销列表新增
export const getTestclaim_expenseListAdd = (params = {}) => {
        params['~table~'] = "mrbase_sys_expense_claim"
        return new Promise((resolve, reject) => {
            http.post('/api/claim_expense/save/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    // /api/claim_expense/money/v1 数据策略 报销新增 汉字金额接口
export const moneyWords = (params = {}) => {
        params['~table~'] = "mrbase_sys_expense_claim"
        return new Promise((resolve, reject) => {
            http.post('/api/claim_expense/money/v1', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
    // 报销删除
export const delClaim = (params = {}) => {
    params['~table~'] = "mrbase_sys_expense_claim"
    return new Promise((resolve, reject) => {
        http.post('/api/claim_expense/del/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}